import { assertNever } from '@kofno/piper';
import { just, Maybe, nothing } from 'maybeasy';
import { action, computed, observable, makeObservable } from 'mobx';
import { Link } from '../Resource/Types';
import { error } from '../ErrorHandling';
import { TPlainTextKey } from '../Translations';
import { errorAlert, FlashAlert } from '../Notifications/Types';
import { ready, waiting, State, ReportsResource, loading } from './Types';

class ReportsStore {
  @observable
  state: State = waiting();

  constructor() {
    makeObservable(this);
  }

  @action
  ready = (resource: ReportsResource) => {
    switch (this.state.kind) {
      case 'loading':
        this.state = ready(resource);
        break;
      case 'waiting':
      case 'ready':
      case 'error':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  loading = () => {
    switch (this.state.kind) {
      case 'waiting':
        this.state = loading();
        break;
      case 'loading':
      case 'ready':
      case 'error':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  error = (msg: TPlainTextKey) => {
    switch (this.state.kind) {
      case 'waiting':
      case 'error':
        break;
      case 'loading':
      case 'ready':
        this.state = error(msg);
        break;
      default:
        assertNever(this.state);
    }
  };

  @computed
  get links(): ReadonlyArray<Link> {
    switch (this.state.kind) {
      case 'ready':
        return this.state.reportsResource.links;
      case 'loading':
      case 'waiting':
      case 'error':
        return [];
    }
  }

  @computed
  get notification(): Maybe<FlashAlert> {
    switch (this.state.kind) {
      case 'error':
        return just(this.state).map(errorAlert);
      case 'ready':
      case 'loading':
      case 'waiting':
        return nothing();
    }
  }
}

export default ReportsStore;
